// Date formatters shared by the CP Sourcing desktop and mobile layouts. Kept in
// their own module (like cpSourcingTheme) so CpDetailDrawer and Mobile/ can both
// import them without importing each other.

// Activity-log timestamps: "04 Aug 2026, 11:30 AM".
export const fmtDateTime = (v) => {
  const d = new Date(v);
  return Number.isNaN(d.getTime())
    ? "—"
    : d.toLocaleString(undefined, {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
};

// Site visit date + time, in the format the desktop DataGrid's VisitDateTime
// cell renders: "Mon Aug 04 2026, 11:30 AM". `dateTime` is epoch ms, sometimes
// as a string, so it is coerced before parsing.
export const fmtVisitDateTime = (dateTime) => {
  if (!dateTime) return "-";
  const d = new Date(Number(dateTime));
  if (Number.isNaN(d.getTime())) return "-";
  return `${d.toDateString()}, ${d.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
};
